import { TCoordinates } from 'views/report/types.ts';
import { TAddTextFieldOptions } from 'views/report/utils/add-text-field/types.ts';
import { getCenterXPosition, toUpperFirstLetter } from 'views/report/utils/utils.ts';
import { blackColor } from 'views/report/colors.ts';
import { fontBold, fontNormal } from 'views/report/utils/style-consts.ts';

export const addTextField = (doc: any, options: TAddTextFieldOptions): TCoordinates => {
  const {
    name,
    value = '',
    isUpperFirstLetter = true,
    nameFontColor,
    x,
    y,
    fontSize = 10,
    useValue = true,
    separator = ':',
    font = fontBold,
    isCentered = false,
  } = options;
  doc.setFontSize(fontSize);

  let nameText: string;

  if (useValue) {
    nameText = isUpperFirstLetter ? toUpperFirstLetter(`${name}${separator} `) : `${name}${separator} `;
  } else {
    nameText = isUpperFirstLetter ? toUpperFirstLetter(name) : name;
  }

  if (nameFontColor) {
    doc.setTextColor(...nameFontColor);
  }

  doc.setFont(font.fontName, font.fontStyle);

  if (isCentered) {
    doc.text(nameText, getCenterXPosition(doc), y, { align: 'center' });
  } else {
    doc.text(nameText, x, y);
  }

  doc.setTextColor(blackColor);

  const nameTextWidth = doc.getTextWidth(nameText);

  doc.setFont(fontNormal.fontName, fontNormal.fontStyle);

  if (useValue) {
    doc.setFontSize(fontSize);
    doc.text(Array.isArray(value) ? value.join(' ') : `${value}`, nameTextWidth + x + 1, y);
  }
  return { x: x || getCenterXPosition(doc), y };
};
